import consumer from "./consumer"

// Only create countdown channel subscription if demo elements exist
let countdownChannel = null;

function initializeCountdownDemo() {
  // Check if we're on the countdown demo page
  const demoContainer = document.getElementById('countdown-demo-container');
  if (!demoContainer) {
    return; // Not on the demo page, don't connect
  }

  // Create countdown channel subscription only for this page
  countdownChannel = consumer.subscriptions.create("CountdownChannel", {
    connected() {
      console.log("Connected to CountdownChannel");
      this.updateStatus("Connected to countdown channel");
    },

    disconnected() {
      console.log("Disconnected from CountdownChannel");
      this.updateStatus("Disconnected from countdown channel");
    },

    received(data) {
      console.log("Received countdown data:", data);
      this.updateStatus("Receiving updates...");
      
      if (data.type === 'countdown') {
        this.updateCountdown(data.number, data.message);
      } else if (data.type === 'complete') {
        this.showComplete(data.message);
      } else if (data.type === 'error') {
        this.showError(data.message);
      }
    },

    // Update the countdown display
    updateCountdown(number, message) {
      const countdownElement = document.getElementById('countdown-number');
      const messageElement = document.getElementById('countdown-message');
      const restartButton = document.getElementById('restart-countdown');
      
      if (countdownElement) {
        countdownElement.textContent = number;
        countdownElement.className = `countdown-number ${number === 0 ? 'complete' : ''}`;
      }
      
      if (messageElement) {
        messageElement.textContent = message;
      }
      
      // Hide restart button during countdown
      if (restartButton) {
        restartButton.style.display = 'none';
      }
    },

    // Show completion state
    showComplete(message) {
      const messageElement = document.getElementById('countdown-message');
      const restartButton = document.getElementById('restart-countdown');
      
      if (messageElement) {
        messageElement.textContent = message;
      }
      
      // Show restart button
      if (restartButton) {
        restartButton.style.display = 'inline-block';
      }
    },

    // Show error state
    showError(message) {
      const messageElement = document.getElementById('countdown-message');
      const restartButton = document.getElementById('restart-countdown');
      const countdownElement = document.getElementById('countdown-number');
      
      if (messageElement) {
        messageElement.textContent = message;
        messageElement.style.color = '#dc3545'; // Red color for errors
      }
      
      if (countdownElement) {
        countdownElement.textContent = '!';
        countdownElement.className = 'countdown-number error';
      }
      
      // Show restart button
      if (restartButton) {
        restartButton.style.display = 'inline-block';
      }
    },

    // Update connection status
    updateStatus(status) {
      const statusElement = document.getElementById('connection-status');
      if (statusElement) {
        statusElement.textContent = status;
      }
    },

    // Action to restart countdown
    restart() {
      this.perform('restart_countdown');
    }
  });

  // Add restart functionality
  const restartButton = document.getElementById('restart-countdown');
  if (restartButton && countdownChannel) {
    restartButton.addEventListener('click', function() {
      countdownChannel.restart();
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initializeCountdownDemo);
